import ja from "./translations/ja";
import en from "./translations/en";
import zh from "./translations/zh";
import zhTW from "./translations/zhTW";
import ko from "./translations/ko";
import es from "./translations/es";
import de from "./translations/de";
import fr from "./translations/fr";
import { Language, Translation, TranslationValue } from "./types";

// すべての言語の翻訳をサポート
export const translations: Partial<Record<Language, Translation>> = {
  ja,
  en,
  zh,
  zhTW,
  ko,
  es,
  de,
  fr,
};

export const supportedLanguages: Language[] = Object.keys(translations) as Language[];

export function translate(
  key: string,
  language: Language,
  params?: Record<string, string | number>
): string {
  const keys = key.split(".");
  let value: TranslationValue = translations[language] || {};

  for (const k of keys) {
    if (value && typeof value === "object" && k in value) {
      value = value[k];
    } else {
      console.warn(
        `[i18n] Translation key not found: "${key}" in language "${language}"`
      );
      return key;
    }
  }

  if (typeof value === "string") {
    if (params) {
      return Object.entries(params).reduce((str, [paramKey, paramVal]) => {
        return str.replace(new RegExp(`{${paramKey}}`, "g"), String(paramVal));
      }, value);
    }
    return value;
  }

  return key;
}

export * from "./types";
